import React, { TextareaHTMLAttributes, forwardRef } from "react";

interface Props {}

const TextArea = forwardRef<
  HTMLTextAreaElement,
  Props & TextareaHTMLAttributes<HTMLTextAreaElement>
>(function TextArea(props, ref) {
  const { className, ...rest } = props;
  return (
    <textarea
      ref={ref}
      className={`p-2 bg-white rounded-lg shadow-sm border w-full h-36 text-sm ${className}`}
      {...rest}
    />
  );
});

export default TextArea;
